import { render } from "./UbicacionRecorrida.vue?vue&type=template&id=6b392774"
import script from "./UbicacionRecorrida.vue?vue&type=script&lang=js"
export * from "./UbicacionRecorrida.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__